import type { HttpShippingMethodDraft } from '@/modules/shippingMethod/infrastructure/dto/HttpShippingMethodDto';

import type { Cart } from '../../domain/Cart';

import type { CartRepository } from './../../domain/CartRepository';

const selectShippingMethod = async (
  repository: CartRepository,
  shippingMethod: HttpShippingMethodDraft[]
): Promise<Cart> => {
  return repository.selectShippingMethod(shippingMethod);
};

export default selectShippingMethod;
